/**
 * FooterNavigation components.
 * @module components/ItaliaTheme/Footer/FooterNavigation
 */

const FooterNavigation = () => null;

export default FooterNavigation;
